import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { backend } from '@shared/datastore/core';
import { searchMyProjectsBuyerBackend } from './search-my-projects-buyer.backend';
// import { DatastoreBackendModule } from '@shared/datastore/core';
import { searchMyProjectsBuyerReducer } from './search-my-projects-buyer.reducer';

// FIXME: remove that
backend.searchMyProjectsBuyer = searchMyProjectsBuyerBackend;

@NgModule({
  imports: [
    StoreModule.forFeature(
      'searchMyProjectsBuyer',
      searchMyProjectsBuyerReducer,
    ),
    /* DatastoreBackendModule.forFeature(
      'searchMyProjectsBuyer',
      searchMyProjectsBuyerBackend,
    ),*/
  ],
})
export class DatastoreSearchMyProjectsBuyerModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/search-my-projects-buyer/search-my-projects-buyer.module.ts